import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { InviteMemberDataService } from '../../../../../shared-services/invite-member-data.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { TryoutProgramService } from '../../../../../services/tryout_Services/tryout-program.service';
import { StorageUtil, AutoUnsubscribe, Subscription, AppState, Store, AppFields, take, filter, Observable, AppTypes } from '../../../../../store';
import { AlertService } from '../../../../../services';
import { isObject } from 'lodash';


@Component({
  selector: 'app-tryout-invite-members',
  templateUrl: './tryout-invite-members.component.html',
  styleUrls: ['./tryout-invite-members.component.css']
})
@AutoUnsubscribe
export class TryoutInviteMembersComponent implements OnInit {
  @Input() reinvite: boolean;
  @Input() users = [];
  @Input() cupfIds = [];

  @Output() getMemberEvent = new EventEmitter();
  @Output() closeSideOverlayEvent = new EventEmitter();

  saving: boolean;

  routeParams;
  InviteForm: FormGroup;
  validationMessages = {};
  programs = [];
  teams = [];
  team;
  TryoutMemberIDArray: any[];
  sub: Subscription = new Subscription();
  feeLoading: boolean;

  fees;
  isTeam: boolean;

  data: Observable<any>;

  constructor(
    private activeRoute: ActivatedRoute,
    private store: Store<AppState>,
    private inviteMemberDataService: InviteMemberDataService,
    private tryoutProgramService: TryoutProgramService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fb: FormBuilder,
    private as: AlertService
  ) {

    this.validationMessages = {
      'TeamGender': 'Gender is required.',
      'Program': 'Program is required.',
      'Team': 'Team is required.',
      'Fee': 'Fee is required.'
    };

    this.data = this.store.select(AppFields.App, AppFields.ClubProgramFees).pipe(filter(p => p !== null));
    this.initForm();
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;

    this.getMemberIds();
  }

  getMemberIds() {
    this.TryoutMemberIDArray = this.inviteMemberDataService.getData();
  }

  initForm() {
    this.InviteForm = this.fb.group({
      TeamGender: [null],
      Program: [null, [Validators.required]],
      Fee: [null],
      Team: [null],
    });

    this.sub.add(this.store.select(AppFields.App, AppFields.TeamAccount).pipe(filter(p => p !== null), take(1)).subscribe(team => {
      this.isTeam = team;

      this.sub.add(this.data.subscribe(res => {
        this.programs = res.programs;

        if (team && res.teams.length === 1) {
          this.InviteForm.controls.Team.patchValue(res.teams[0].teamID);
          this.teams = res.teams.filter(t => !t.archived);
          this.team = this.teams[0];
        } else {
          this.sub.add(this.InviteForm.controls.TeamGender.valueChanges.subscribe(g => {
            this.teams = res.teams.filter(t => (g === 'b' || t.gender && t.gender.toLowerCase() === g) && !t.archived);

            if (this.teams.length === 1) {
              this.InviteForm.controls.Team.patchValue(this.teams[0].teamID);
            }
          }));
        }

        this.sub.add(this.InviteForm.controls.Program.valueChanges.subscribe(p => {
          this.fees = res.fees.filter(f => f.clubprogramID === +p);
          if (this.fees.length === 1) {
            this.InviteForm.controls.Fee.patchValue(this.fees[0].clubprogramfeeID);
          }
        }));

        if (this.programs.length === 1) {
          this.InviteForm.controls.Program.patchValue(this.programs[0].clubprogramID);
        }

      }));
    }));

  }

  onCancle() {
    this.closeSideOverlayEvent.emit();
    this.InviteForm.reset();
    for (let i = 0; i < this.TryoutMemberIDArray.length; i++) {
      this.TryoutMemberIDArray.splice(this.TryoutMemberIDArray.indexOf(i), 1);
    }
  }

  validateUi() {
    Object.keys(this.InviteForm.controls).forEach(field => {
      const control = this.InviteForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  onSave(event, status) {
    event.preventDefault();
    event.stopPropagation();
    this.validateUi();

    const data = this.InviteForm.value;
    if (status === 'VALID') {
      let inviteLink = data.Program;
      if (data.Fee) {
        inviteLink += '-' + data.Fee;

        if (data.Team) {
          inviteLink += '-' + data.Team;
        }
      }

      const OBJ = {
        clubprogramID: +data.Program,
        userID: this.users,
        teamID: +data.Team || 0,
        addedby: StorageUtil.userID,
        feeID: +data.Fee,
        tryoutClubProgramID: this.routeParams.id,
        inviteLink,
        ClubUserProgramFeeIDList: this.cupfIds,
        reinvite: this.reinvite || true
      };
      this.saving = true;
      this.spinnerService.show();
      const clubId = +localStorage.getItem('clubId');
      this.tryoutProgramService.sendInvite(clubId, OBJ).subscribe(
        () => {
          this.saving = false;
          this.spinnerService.hide();
          this.as.success("Sent Successfully.");
          this.InviteForm.reset();
          this.getMemberEvent.emit();
          this.closeSideOverlayEvent.emit();
        },
        () => {
          this.saving = false;
          this.as.error('Something went wrong');
          this.spinnerService.hide();
        }
      );
    }
  }

  isValidGender() {
    return this.InviteForm.get('TeamGender').errors
      && (this.InviteForm.get('TeamGender').touched
        || this.InviteForm.get('TeamGender').dirty);
  }

  isValidProgram() {
    return this.InviteForm.get('Program').errors
      && (this.InviteForm.get('Program').touched
        || this.InviteForm.get('Program').dirty);
  }

  isValid(field: string) {
    return this.InviteForm.get(field).errors
      && (this.InviteForm.get(field).touched
        || this.InviteForm.get(field).dirty);
  }

  isValidTeam() {
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-members/partial/tryout-invite-members/tryout-invite-members.component.ts